/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Display_Name_HelpInputs */



/**
* | output |
* | --- |
* | "The name that will be displayed for this group" |
*
* @param {Edit_Event_Group_Display_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_display_name_help = /** @type {((inputs?: Edit_Event_Group_Display_Name_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Display_Name_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom qui sera affiché pour ce groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Name, der für diese Gruppe angezeigt wird")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome che verrà visualizzato per questo gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название, которое будет отображаться для этой группы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre que se mostrará para este grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此组将显示的名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このグループに表示される名前")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस समूह के लिए प्रदर्शित होने वाला नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O nome que será exibido para este grupo")
	return /** @type {LocalizedString} */ ("The name that will be displayed for this group")
});